import { useTranslation } from 'react-i18next'
import { Outlet } from '@tanstack/react-router'
import { BillingFilters } from '../components/data/BillingFilters/BillingFilters'
import { useBillingPaymentsHeaderSlot } from '../features/BillingPayments/components/BillingPaymentsHeaderSlot/useBillingPaymentsHeaderSlot'
import { BillingPaymentsHeaderSlotProvider } from '../features/BillingPayments/components/BillingPaymentsHeaderSlot/BillingPaymentsHeaderSlotProvider'
import { ReportHeader } from '@/features/Reporting/components/ReportHeader/ReportHeader'
import { PageTitle } from '@/components'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'
import { BillingTabs } from '@/features/BillingPayments/BillingTabs/BillingTabs'
import { FilterError } from '@/components/common/FilterError/FilterError'
import { useNodesCommoditiesFiltersError } from '@/hooks/useNodesCommoditiesFiltersError/useNodesCommoditiesFiltersError'

export const BillingPayments = () => {
    const { t } = useTranslation('translations')
    const { slot } = useBillingPaymentsHeaderSlot()
    const title = t('sidebar_menu.billing_and_payments')
    const { isFiltersError } = useNodesCommoditiesFiltersError()

    return (
        <div className="grid h-full grid-cols-[100%] grid-rows-[auto_1fr]">
            <div className="space-y-6">
                <ReportHeader
                    title={title}
                    renderTitle={() => (
                        <PageTitle
                            label={title}
                            labelTestId={'page-title-billing-and-payments'}
                        />
                    )}
                >
                    {slot}
                </ReportHeader>
                <RoleRestrictedContent
                    allowedRoles={[UserType.CUSTOMER]}
                    strict={false}
                >
                    <BillingTabs />
                    {isFiltersError ? (
                        <FilterError />
                    ) : (
                        <div className="relative z-30 px-6">
                            <BillingFilters />
                        </div>
                    )}
                </RoleRestrictedContent>
            </div>
            {!isFiltersError && <Outlet />}
        </div>
    )
}

const BillingPaymentsWithContext = () => {
    return (
        <BillingPaymentsHeaderSlotProvider>
            <BillingPayments />
        </BillingPaymentsHeaderSlotProvider>
    )
}

export default BillingPaymentsWithContext
